module.exports = __webpack_public_path__ + "img/Dantam Bridal 26.78138c58.jpg";